export default {
  common: {
    colon: ': ',
    comma: ', ',
    slash: ' / ',
    yes: 'はい',
    no: 'いいえ',
    cancel: 'キャンセル',
    confirm: '確認',
    back: '戻る',
    backToTickets: 'チケット一覧に戻る',
    backToTicketDetails: 'チケット詳細に戻る',
    day: ' 日',
    hour: '時間',
    min: '分',
    second: '秒'
  },
  views: {
    limousine: {
      statusHeading: {
        INVALID: '無効',
        AWAITING: '使用前',
        UNUSED: '使用前',
        USABLE: '使用前',
        IN_USE: '使用中',
        USED: '使用済み',
        EXPIRED: '期限切れ',
        DISTRIBUTED: '分配済み',
        RETURNED: '返却済み'
      },
      unavailable: 'このチケットは\nご利用頂けません',
      usedInfo: '利用済み情報',
      gateTime: '改札日時 {{date}}',
      passengerCount: '{{title}} {{count}}名',
      adultUnitTitle: '大人',
      childUnitTitle: '小児',
      childBadge: '小',
      inUseClockNote: '30分間、改札できます',
      journeyInfo: '乗車情報',
      from: 'FROM',
      to: 'TO',
      expirationDate: 'EXPIRATION DATE / 有効期限',
      route: 'ROUTE / 路線',
      rateType: 'RATE TYPE / 料金区分',
      amount: '{{amount}}円',
      status: 'STATUS / ステータス',
      usedStampAlt: '使用済',
      gate: '改札する',
      gateDrawerInstruction:
        'チケットを使用するボタンを押してから30分以内にチケットをご提示ください',
      useTicket: 'チケットを使用する',
      outsideAvailablePeriod: 'チケットを使用できる期間ではありません。',
      availablePeriod: '使用可能期間：',
      availableFrom: '{{date}} から',
      availableTo: '{{date}} まで',
      history: '乗車履歴',
      availableRoutes: 'ご利用可能な路線を見る',
      bookingInfo: '予約情報',
      bookingId: 'Booking ID：',
      purchasedAt: '購入日時：{{date}}'
    },
    linkTrain: {
      title: '新幹線QRチケット',
      unavailable: 'チケットを表示できません。',
      instructions: 'ご利用方法',
      notice1:
        '※QRコードを使用してそのまま駅にご入場ください。紙のチケットへの引き換えはできません。',
      notice2:
        '※乗車用QRコードはお客様ごとに異なります。スムーズにご乗車いただくため、事前に同行者それぞれへQRコード付きチケットをお送りください。通信トラブルに備え、スクリーンショットの保存または印刷をおすすめします。'
    },
    common: {
      colon: '：',
      submit: '送信',
      resend: '再送信',
      cancel: 'キャンセル',
      confirm: '確認',
      tickets: 'チケット一覧',
      copyBtn: 'URLをコピー',
      recommendBrowserTips:
        '非推奨のブラウザでアクセスしています。推奨のブラウザを利用しアクセスしてください。'
    },
    voucher: {
      title: 'デジタルバウチャー',
      bookingId: '予約番号',
      ticketInfo: 'チケット情報',
      bookingInfo: '予約情報',
      bookingDetails: '予約詳細',
      printable: '印刷用バウチャー',
      participation: '集合・引換場所の説明',
      inclusion: '含まれるもの',
      restrictions: '参加制限',
      requiredAttire: '参加時必要な服装・持ち物',
      requirements: '参加前、参加時必要事項',
      other: '備考・その他',
      localContact: '現地連絡先',
      cancellation: 'キャンセルポリシー',
      clickUrl: 'チケットを使用するにはこのリンクをクリックしてください',
      unitAdditionalLabel: '{{unitTitle}}{{unitIndex}} 追加予約情報'
    },
    booking: {
      details: '予約詳細',
      bookingId: 'Booking {{id}}',
      history: '利用履歴',
      bookedDate: '予約日',
      participationLocations: '参加場所',
      participationLocationKind: {
        MAP_OF_MEETING_POINT: '場所説明',
        NOTE_OF_LOCATION_AND_DIRECTION: '場所、行き方の補足説明',
        LANDMARKS_TO_MEETING_POINT: '集合場所までのランドマーク',
        PICK_UP_CAR: '迎えに行く車',
        PICK_UP_GUIDE: '迎えに行くガイド',
        ITINERARY: 'スケジュール',
        PARKING: '駐車場について'
      },
      ticketType: {
        CODE_CPM: 'QRコードをかざす',
        CODE_MPM: 'QRコードを読み取る',
        BARCODE_CPM: 'バーコードを表示',
        SELF_REDEMPTION: 'チケット表示',
        SIMPLE_VOUCHER: 'チケット表示'
      },
      inclusion: '含まれるもの',
      restrictions: '参加制限',
      requirements: '参加前・参加時必要事項',
      attireItems: '参加時必要な服装・持ち物',
      otherInfo: '備考・その他',
      cancellationPolicy: 'キャンセルポリシー'
    },
    otp: {
      title: 'ワンタイムパスワード',
      tips1:
        'お客様のアクセス環境が変わりました。 \n セキュリティ保護のため、ワンタイムパスワードによる認証を行います。',
      tips2: 'ワンタイムパスワードを受け取るメールアドレスを登録してください。',
      inputOTPCode:
        'メールに記載されているワンタイムパスワードを入力してください。',
      sendCode:
        '{{email}} にワンタイムパスワードを送付しました。メールを確認してください。',
      invalidEmail: '無効なメールアドレスです。',
      inputEmail: 'メールアドレスを入力してください。',
      inputPassword: 'ワンタイムパスワードを入力してください。',
      sendOTP: 'ワンタイムパスワードを送信する'
    },
    ticket: {
      status: {
        INVALID: '無効',
        AWAITING: '利用可能期間前',
        UNUSED: '利用前',
        USABLE: '利用可能',
        IN_USE: '利用中',
        USED: '利用済み',
        EXPIRED: '期限切れ',
        DISTRIBUTED: '同行者に分配済み',
        RETURNED: '同行者への分配を返却済み'
      },
      subStatus: {
        ENTERED: '入場',
        EXITED: '出場',
        INITIAL_STATION_CANCELLED: '乗車駅キャンセル'
      },
      nowTime: '現在時刻',
      startTime: '開始時間',
      QRCodeExpirationRemainingTime: 'QRコード有効期限残り',
      QRCodeAwaiting: '利用可能期間が始まると、QRコードが表示されます',
      screenShotTips: 'スクリーンショットでのご利用は不可です。',
      showScreenToStaff: 'この画面をスタッフにご提示ください。',
      scanFailedTips:
        'スキャンに失敗した場合は、QRコードをタップして更新してください。',
      instruction: '利用説明',
      usedAt: '利用日',
      availablePeriod: '利用可能期間',
      bookingId: '予約番号',
      startUsing: '利用開始',
      startUsingTips: 'チケットの利用を開始しますか？',
      startUsingWarn: '*利用開始と同時に有効期間が開始となります。',
      selfRedemptionOptionPresetPlaceholder: '利用先を選択する',
      distributeTicket: '分配',
      distributedTicket: '分配済み',
      distributeTicketTips:
        '分配ボタンよりリンクをコピーできない場合、上記のURLをコピーして同行者へ分配してください',
      reDistributeTicket: '再分配する',
      reDistributeTips:
        '※同行者がチケット『未使用』の場合のみ再分配はできます。',
      reDistributeTips2: '※再分配後、分配したリンクが無効になります。',
      copyLinkSuccess: 'リンクをコピーしました。',
      use: '利用',
      confirmUse: '利用内容の確認',
      useTicket: '<span>{{count}}</span>枚を利用します',
      issueTicketTips: '係員の前で利用してください',
      issueTicketNotes: '※利用後は取消不可となります',
      undo: '取り消し',
      redeem: '利用開始',
      thanks: 'ご利用ありがとうございます',
      second: '{{count}}秒',
      expirationDate: '有効期限',
      supplier: '催行会社',
      participatorName: '参加者名',
      validPeriod: '利用後有効期間',
      fixedTime: '{{day}}日間(最終日は現地時刻{{time}}まで)',
      enableCamera: 'カメラ機能を有効にしてください。',
      qrTip: 'QRコードを枠内に入れると自動スキャンされます',
      accessDeniedTip: 'カメラアクセスが拒否されました',
      manualVerify: '手動検証',
      unit: '{{unit}} {{index}}',
      afterUse: '利用後',
      participationDate: '参加日',
      participationTime: '開始時間'
    },
    confirmUse: {
      title: '利用開始しますか？',
      usedTitle: '利用しました！',
      tips: '必ずスタッフの前にスライドしてください。事前利用したら入場できなくなります。',
      usedTips: 'チケットの再利用はできません。良い旅を！',
      lockedText: 'スタッフ前でスライド',
      unlockText: '利用済み',
      returnText: '戻る',
      closeText: '閉じる'
    },
    history: {
      title: '利用履歴'
    },
    advanced: {
      title: '駅係員機能',
      success: '駅係員処理が完了しました。'
    },
    apiErrors: {
      baseError: 'エラーが発生しました。',
      clientError: 'クライアントからのリクエストに誤りがありました。',
      serverError: 'サーバがリクエストの処理に失敗しました。',
      connectionError:
        '接続エラーが発生しました。通信環境をご確認して、再度お試しください。',
      requestError: 'リクエストの作成に誤りがありました。'
    }
  }
};
